/* sdx-ingredients-library — SSR hydrate (R11) + JSON drawer + filter + search
   R11: grid SERVER-RENDERED (<a> kartlar, data-ssr="1") → JS yalnız enhancement:
   filtre/arama hide-show + tıklamada drawer (navigasyonu keser). Entity index
   boşsa legacy JSON-render yolu korunur (data-ssr yok → renderGrid). */
(function () {
  'use strict';

  // R7 m29 — Latin binom regex wrap
  // Wraps "(Genus species ...)" into <em class="sdx-latin">…</em> for HTML strings.
  function wrapLatinBinom(html) {
    if (!html) return html;
    // Capital-cased binom in parens: "(Tymbra spicata)" or "(Tymbra spicata L.)"
    return String(html).replace(
      /\(([A-Z][a-zçğıöşü]+(?:\s+[a-zçğıöşü]+)?(?:\s+[A-Za-z\.]+)?)\)/g,
      function(match, inner) {
        // Skip if already wrapped or contains digits / known non-latin words
        if (/[0-9]/.test(inner)) return match;
        return '(<em class="sdx-latin">' + inner + '</em>)';
      }
    );
  }


  const root = document.querySelector('[data-sdx-ilib]');
  if (!root) return;

  const srcUrl = root.getAttribute('data-source');
  const grid = root.querySelector('[data-sdx-ilib-grid]');
  const filtersWrap = root.querySelector('[data-sdx-ilib-filters]');
  const searchInput = root.querySelector('[data-sdx-ilib-search]');
  const metaEl = root.querySelector('[data-sdx-ilib-meta]');
  const emptyEl = root.querySelector('[data-sdx-ilib-empty]');
  const loadingEl = root.querySelector('[data-sdx-ilib-loading]');
  const drawer = document.querySelector('[data-sdx-ilib-drawer]');
  const drawerBody = drawer ? drawer.querySelector('[data-sdx-ilib-drawer-body]') : null;
  const isSSR = !!(grid && grid.getAttribute('data-ssr') === '1');

  // Move drawer to body root — section wrapper bazen z-index/transform oluşturur,
  // fixed konumlu drawer'ı sınırlayıp üst bölgede ölü tıklama yaratabilir.
  if (drawer && drawer.parentElement !== document.body) {
    document.body.appendChild(drawer);
  }

  let state = {
    data: null,
    filter: 'all',
    search: '',
    byId: {},
  };

  function initialsOf(name) {
    const parts = name.split(/\s+/).filter(Boolean);
    const first = parts[0] || '';
    const second = parts.length > 1 ? parts[parts.length - 1] : '';
    return (first.charAt(0) + (second.charAt(0) || '')).toUpperCase();
  }

  function syncFilterPressed() {
    if (!filtersWrap) return;
    filtersWrap.querySelectorAll('[data-sdx-ilib-filter]').forEach((btn) => {
      btn.setAttribute('aria-pressed', state.filter === btn.getAttribute('data-sdx-ilib-filter') ? 'true' : 'false');
    });
  }

  function bindFilterButtons() {
    if (!filtersWrap) return;
    filtersWrap.querySelectorAll('[data-sdx-ilib-filter]').forEach((btn) => {
      if (btn.dataset.sdxBound === '1') return;
      btn.dataset.sdxBound = '1';
      btn.addEventListener('click', () => {
        state.filter = btn.getAttribute('data-sdx-ilib-filter');
        syncFilterPressed();
        renderGrid();
      });
    });
  }

  function renderFilters() {
    if (!filtersWrap) return;
    if (isSSR) {
      // SSR: butonlar server-rendered — yalnız bind + state sync
      bindFilterButtons();
      syncFilterPressed();
      return;
    }
    if (!state.data) return;
    const cats = [{ key: 'all', label: 'Tümü' }].concat(state.data.categories || []);
    filtersWrap.innerHTML = cats.map((c) => {
      const pressed = state.filter === c.key ? 'true' : 'false';
      return `<button type="button" class="sdx-ilib__filter-btn" data-sdx-ilib-filter="${c.key}" aria-pressed="${pressed}">${c.label}</button>`;
    }).join('');
    bindFilterButtons();
  }

  // R7 m24 — TR/EN alias map for ingredient search
  const SDX_SEARCH_ALIASES = {
    'c vitamini': ['vitamin c'],
    'd vitamini': ['vitamin d3', 'vitamin d', 'd3 vitamini'],
    'b vitamini': ['vitamin b12', 'vitamin b6', 'vitamin b'],
    'a vitamini': ['vitamin a'],
    'e vitamini': ['vitamin e'],
    'k vitamini': ['vitamin k2', 'vitamin k'],
    'd3 vitamini': ['vitamin d3', 'd vitamini'],
    'omega 3': ['epa', 'dha', 'balik yagi'],
    'magnezyum': ['magnesium'],
    'demir': ['iron', 'lipofer'],
    'kolajen': ['collagen'],
    'biotin': ['biotin', 'b7 vitamini', 'b7'],
    'çinko': ['zinc', 'cinko'],
    'cinko': ['çinko', 'zinc'],
    'selenyum': ['selenium'],
    'q10': ['koenzim q10', 'coenzyme q10'],
  };
  function sdxNormalize(s) {
    return String(s || '').toLocaleLowerCase('tr-TR')
      .replace(/[ıİ]/g, 'i').replace(/[şŞ]/g, 's').replace(/[ğĞ]/g, 'g')
      .replace(/[üÜ]/g, 'u').replace(/[öÖ]/g, 'o').replace(/[çÇ]/g, 'c')
      .replace(/\s+/g, ' ').trim();
  }
  function sdxExpandQuery(q) {
    const norm = sdxNormalize(q);
    const expanded = new Set([norm]);
    Object.keys(SDX_SEARCH_ALIASES).forEach((k) => {
      if (norm.includes(k)) {
        SDX_SEARCH_ALIASES[k].forEach((a) => expanded.add(sdxNormalize(a)));
      }
      // reverse: if any value matches, add the key
      if (SDX_SEARCH_ALIASES[k].some((a) => norm.includes(sdxNormalize(a)))) {
        expanded.add(k);
      }
    });
    return Array.from(expanded);
  }

  function matches(rec) {
    if (state.filter !== 'all' && !((rec.categories && rec.categories.length ? rec.categories : [rec.category]).includes(state.filter))) return false; /* R7.2 m27 multi-cat */
    if (!state.search) return true;
    const qs = sdxExpandQuery(state.search);
    const recName = sdxNormalize(rec.name);
    const recLatin = sdxNormalize(rec.latin_name || '');
    const recTags = (rec.tags || []).map(sdxNormalize);
    const recAliases = (rec.search_aliases || []).map(sdxNormalize);
    for (let i = 0; i < qs.length; i++) {
      const q = qs[i];
      if (!q) continue;
      if (recName.includes(q)) return true;
      if (recLatin && recLatin.includes(q)) return true;
      if (recTags.some((t) => t.includes(q))) return true;
      if (recAliases.some((a) => a.includes(q))) return true;
    }
    return false;
  }

  // SSR kart → pseudo-record (data-* attribute'lardan)
  function recOfCard(card) {
    const cats = (card.getAttribute('data-cats') || '').split(',').filter(Boolean);
    return {
      name: card.getAttribute('data-name') || '',
      latin_name: card.getAttribute('data-latin') || '',
      tags: (card.getAttribute('data-tags') || '').split('|').filter(Boolean),
      categories: cats,
      category: cats[0] || 'diger',
    };
  }

  function applyFilterSSR() {
    const cards = grid.querySelectorAll('[data-sdx-ilib-card]');
    let shown = 0;
    cards.forEach((card) => {
      const ok = matches(recOfCard(card));
      card.hidden = !ok;
      if (ok) shown++;
    });
    if (emptyEl) emptyEl.hidden = shown > 0;
    if (metaEl) metaEl.textContent = `${shown} / ${cards.length} içerik gösteriliyor`;
  }

  function renderGrid() {
    if (!grid) return;
    if (isSSR) { applyFilterSSR(); return; }
    if (!state.data) return;
    const items = (state.data.ingredients || []).filter(matches);
    const cards = items.map((rec) => {
      const init = initialsOf(rec.name);
      const sub = rec.tags && rec.tags.length ? rec.tags.slice(0, 2).join(' · ') : (rec.latin_name || '');
      const iconHtml = rec.image
        ? `<span class="sdx-ilib__card-icon sdx-ilib__card-icon--img" aria-hidden="true"><img src="${imageUrlWithSize(rec.image, 200)}" alt="" loading="lazy"></span>`
        : `<span class="sdx-ilib__card-icon" aria-hidden="true">${init}</span>`;
      return `<button type="button" class="sdx-ilib__card" data-sdx-ilib-card data-id="${rec.id}">
        ${iconHtml}
        <span class="sdx-ilib__card-text">
          <span class="sdx-ilib__card-name">${escapeHtml(rec.name)}</span>
          ${sub ? `<span class="sdx-ilib__card-sub">${wrapLatinBinom(escapeHtml(sub))}</span>` : ''}
        </span>
      </button>`;
    }).join('');

    grid.querySelectorAll('[data-sdx-ilib-card]').forEach((n) => n.remove());
    if (loadingEl) loadingEl.hidden = true;
    if (emptyEl) emptyEl.hidden = items.length > 0;
    grid.insertAdjacentHTML('beforeend', cards);

    if (metaEl) {
      const total = (state.data.ingredients || []).length;
      metaEl.textContent = `${items.length} / ${total} içerik gösteriliyor`;
    }

    bindCardClicks();
  }

  function bindCardClicks() {
    grid.querySelectorAll('[data-sdx-ilib-card]').forEach((btn) => {
      if (btn.dataset.sdxBound === '1') return;
      btn.dataset.sdxBound = '1';
      btn.addEventListener('click', (e) => {
        const id = btn.getAttribute('data-id');
        // SSR kartı gerçek <a> — drawer verisi hazırsa navigasyonu kes, drawer aç;
        // veri yoksa/parse edilemediyse link doğal çalışır (progressive fallback).
        if (state.byId[id]) {
          e.preventDefault();
          openDrawer(id);
        }
      });
    });
  }

  function escapeHtml(s) {
    return String(s || '').replace(/[&<>"']/g, (c) => ({
      '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;'
    })[c]);
  }

  function categoryLabel(key) {
    if (!state.data) return '';
    const c = (state.data.categories || []).find((x) => x.key === key);
    return c ? c.label : key;
  }

  function imageUrlWithSize(url, w) {
    if (!url) return '';
    if (url.indexOf('?') === -1) return url + '?width=' + w;
    if (/[?&]width=/.test(url)) return url;
    return url + '&width=' + w;
  }


  // R10.1 — referanslar metaobject `references` alanından (panel-yönetimli);
  // function_text auto-split kaldırıldı.
  // R7 m21 — render references block (separate from function_text)
  function renderReferencesBlock(refs) {
    if (!refs || !refs.length) return '';
    const lis = refs.map(r => '<li>' + escapeHtml(r) + '</li>').join('');
    return '<section class="sdx-ilib-drawer__block sdx-ilib-drawer__references">' +
           '<h3 class="sdx-ilib-drawer__section-title">Referanslar</h3>' +
           '<ul class="sdx-ilib-drawer__references-list">' + lis + '</ul>' +
           '</section>';
  }

  function drawerMarkup(rec) {
    const tags = (rec.tags || []).map((t) =>
      `<li class="sdx-ilib-drawer__tag">${escapeHtml(t)}</li>`
    ).join('');
    const benefits = (rec.benefits || []).filter(Boolean);
    const benefitsHtml = benefits.length ? `
      <section class="sdx-ilib-drawer__block">
        <h3 class="sdx-ilib-drawer__section-title">Faydalar</h3>
        <ul class="sdx-ilib-drawer__benefits">
          ${benefits.map((b) => `<li class="sdx-ilib-drawer__benefit">
            <svg class="sdx-ilib-drawer__benefit-icon" viewBox="0 0 24 24" width="14" height="14" fill="none" stroke="currentColor" stroke-width="3" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><polyline points="20 6 9 17 4 12"/></svg>
            <span>${escapeHtml(b)}</span>
          </li>`).join('')}
        </ul>
      </section>
    ` : '';

    const infoRows = [];
    if (rec.daily_dose) infoRows.push({ label: 'Günlük doz aralığı', value: rec.daily_dose });
    if (rec.food_sources) infoRows.push({ label: 'Doğal kaynaklar', value: rec.food_sources });
    let funcBody = rec.function_text || '';
    let funcRefs = rec.references || [];
    if (funcBody) infoRows.push({ label: 'Vücuttaki işlevi', value: funcBody });
    if (rec.country_of_origin) infoRows.push({ label: 'Menşei', value: rec.country_of_origin });
    const infoHtml = infoRows.length ? `
      <dl class="sdx-ilib-drawer__info">
        ${infoRows.map((r) => `
          <div class="sdx-ilib-drawer__info-row">
            <dt class="sdx-ilib-drawer__info-label">${escapeHtml(r.label)}</dt>
            <dd class="sdx-ilib-drawer__info-value">${wrapLatinBinom(escapeHtml(r.value))}</dd>
          </div>
        `).join('')}
      </dl>
    ` : '';

    const analyses = (rec.raw_material_analysis || []).filter(Boolean);
    const analysesHtml = analyses.length ? `
      <section class="sdx-ilib-drawer__block sdx-ilib-drawer__analyses">
        <h3 class="sdx-ilib-drawer__section-title">Hammadde Analizleri</h3>
        <ul class="sdx-ilib-drawer__analysis-list">
          ${analyses.map((u, i) => `
            <li>
              <a class="sdx-ilib-drawer__analysis-link" href="${u}" target="_blank" rel="noopener">
                <svg viewBox="0 0 24 24" width="18" height="18" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z"/><polyline points="14 2 14 8 20 8"/></svg>
                <span>Analiz ${i + 1} — Görüntüle</span>
                <svg viewBox="0 0 24 24" width="14" height="14" fill="none" stroke="currentColor" stroke-width="2.4" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true" style="margin-left:auto"><path d="M7 17 17 7"/><path d="M8 7h9v9"/></svg>
              </a>
            </li>
          `).join('')}
        </ul>
      </section>
    ` : '';

    const products = (rec.products || []).map((p) => `
      <li>
        <a class="sdx-ilib-drawer__product" href="/products/${encodeURIComponent(p.handle)}">
          ${p.image ? `<img class="sdx-ilib-drawer__product-img" src="${imageUrlWithSize(p.image, 96)}" alt="" loading="lazy">` : '<span class="sdx-ilib-drawer__product-img"></span>'}
          <span class="sdx-ilib-drawer__product-info">
            <span class="sdx-ilib-drawer__product-title">${escapeHtml(p.title)}</span>
            ${(p.amount || p.nrv) ? `<span class="sdx-ilib-drawer__product-meta">${escapeHtml([p.amount, p.nrv].filter(Boolean).join(' · '))}</span>` : ''}
          </span>
          <svg class="sdx-ilib-drawer__product-arrow" viewBox="0 0 24 24" width="16" height="16" fill="none" stroke="currentColor" stroke-width="2.4" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><polyline points="9 6 15 12 9 18"/></svg>
        </a>
      </li>
    `).join('');

    const heroImg = rec.image ? `
      <div class="sdx-ilib-drawer__hero">
        <img src="${imageUrlWithSize(rec.image, 1080)}" alt="${escapeHtml(rec.name)}" loading="lazy">
      </div>
    ` : '';

    // R11 — drawer başlığından kanonik sayfaya link (drawer UX + crawl köprüsü)
    const card = grid ? grid.querySelector('[data-sdx-ilib-card][data-id="' + (window.CSS && CSS.escape ? CSS.escape(rec.id) : rec.id) + '"]') : null;
    const pageHref = card && card.tagName === 'A' && card.getAttribute('href') && card.getAttribute('href').charAt(0) !== '#'
      ? card.getAttribute('href') : '';
    const pageLink = pageHref ? `<p class="sdx-ilib-drawer__pagelink"><a href="${pageHref}">İçerik sayfasını aç <svg viewBox="0 0 24 24" width="12" height="12" fill="none" stroke="currentColor" stroke-width="2.4" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M7 17 17 7"/><path d="M8 7h9v9"/></svg></a></p>` : '';

    return `
      <div class="sdx-ilib-drawer__hero-row">
      ${heroImg}
      <div class="sdx-ilib-drawer__head">
        <span class="sdx-ilib-drawer__category">${escapeHtml(categoryLabel(rec.category))}</span>
        <h2 class="sdx-ilib-drawer__name">${escapeHtml(rec.name)}</h2>
        ${rec.latin_name ? `<p class="sdx-ilib-drawer__latin">${escapeHtml(rec.latin_name)}</p>` : ''}
        ${tags ? `<ul class="sdx-ilib-drawer__tags">${tags}</ul>` : ''}
        ${pageLink}
      </div>
      </div>
      ${rec.description ? `<p class="sdx-ilib-drawer__description">${wrapLatinBinom(escapeHtml(rec.description)).replace(/\n+/g, '<br>')}</p>` : ''}
      ${benefitsHtml}
      ${infoHtml}
      ${analysesHtml}
      ${renderReferencesBlock(funcRefs)}
      ${products ? `<section class="sdx-ilib-drawer__block">
        <h3 class="sdx-ilib-drawer__section-title">Sidrex ürünlerinde</h3>
        <ul class="sdx-ilib-drawer__products">${products}</ul>
      </section>` : ''}
      ${rec.health_claims && rec.health_claims.length ? `
        <section class="sdx-ilib-drawer__block">
          <button type="button" class="sdx-drawer__health-claims-btn" data-sdx-hc-open data-rec-id="${rec.id}">
            <svg viewBox="0 0 24 24" width="18" height="18" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M9 12l2 2 4-4"/><circle cx="12" cy="12" r="10"/></svg>
            <span>Sağlık Beyanları</span>
            <span class="sdx-drawer__hc-count">(${rec.health_claims.length})</span>
          </button>
        </section>` : ''}
      ${rec.evidence_url ? `<p class="sdx-ilib-drawer__evidence"><a href="${rec.evidence_url}" target="_blank" rel="noopener">Bilimsel kaynak <svg viewBox="0 0 24 24" width="12" height="12" fill="none" stroke="currentColor" stroke-width="2.4" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M7 17 17 7"/><path d="M8 7h9v9"/></svg></a></p>` : ''}
    `;
  }

  function openDrawer(id) {
    if (!drawer || !drawerBody) return;
    const rec = state.byId[id];
    if (!rec) return;
    drawerBody.innerHTML = drawerMarkup(rec);
    drawer.setAttribute('aria-hidden', 'false');
    document.body.style.overflow = 'hidden';
    const closeBtn = drawer.querySelector('[data-sdx-ilib-drawer-close]');
    if (closeBtn) closeBtn.focus();
    if (history.replaceState) {
      const url = new URL(window.location.href);
      url.hash = 'icerik-' + id;
      history.replaceState(null, '', url.toString());
    }
  }

  function closeDrawer() {
    if (!drawer) return;
    drawer.setAttribute('aria-hidden', 'true');
    document.body.style.overflow = '';
    if (history.replaceState) {
      const url = new URL(window.location.href);
      url.hash = '';
      history.replaceState(null, '', url.pathname + url.search);
    }
  }



  // R7 m23 — Sağlık Beyanları popup
  function ensureHealthClaimsPopup() {
    if (document.getElementById('sdx-hc-popup')) return document.getElementById('sdx-hc-popup');
    const div = document.createElement('div');
    div.id = 'sdx-hc-popup';
    div.className = 'sdx-health-claims-popup';
    div.setAttribute('aria-hidden', 'true');
    div.setAttribute('role', 'dialog');
    div.innerHTML = '<div class="sdx-health-claims-popup__backdrop" data-sdx-hc-close></div>' +
                    '<div class="sdx-health-claims-popup__panel">' +
                      '<button type="button" class="sdx-health-claims-popup__close" data-sdx-hc-close aria-label="Kapat">' +
                        '<svg viewBox="0 0 24 24" width="20" height="20" fill="none" stroke="currentColor" stroke-width="2.4" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><line x1="18" y1="6" x2="6" y2="18"/><line x1="6" y1="6" x2="18" y2="18"/></svg>' +
                      '</button>' +
                      '<div class="sdx-health-claims-popup__body"></div>' +
                    '</div>';
    document.body.appendChild(div);
    div.querySelectorAll('[data-sdx-hc-close]').forEach((el) => {
      el.addEventListener('click', closeHealthClaims);
    });
    return div;
  }
  function openHealthClaims(recId) {
    const rec = state.byId[recId];
    if (!rec || !rec.health_claims || !rec.health_claims.length) return;
    const popup = ensureHealthClaimsPopup();
    const body = popup.querySelector('.sdx-health-claims-popup__body');
    const lis = rec.health_claims.map(hc => {
      const t = (typeof hc === 'string') ? hc : (hc.text || hc.statement || hc.title || JSON.stringify(hc));
      return '<li class="sdx-health-claims-popup__item">' + escapeHtml(t) + '</li>';
    }).join('');
    body.innerHTML = '<h3 class="sdx-health-claims-popup__title">' + escapeHtml(rec.name) + ' — Sağlık Beyanları</h3>' +
                     '<ul class="sdx-health-claims-popup__list">' + lis + '</ul>' +
                     '<p class="sdx-health-claims-popup__disclaimer">Takviye edici gıdadır. Normal beslenmenin yerine geçmez. Hastalıkların önlenmesi veya tedavisi amacıyla kullanılmaz.</p>';
    popup.setAttribute('aria-hidden', 'false');
    document.body.style.overflow = 'hidden';
  }
  function closeHealthClaims() {
    const popup = document.getElementById('sdx-hc-popup');
    if (popup) popup.setAttribute('aria-hidden', 'true');
    document.body.style.overflow = '';
  }
  document.addEventListener('click', (e) => {
    const btn = e.target.closest('[data-sdx-hc-open]');
    if (btn) {
      e.preventDefault();
      openHealthClaims(btn.getAttribute('data-rec-id'));
    }
  });
  document.addEventListener('keydown', (e) => {
    if (e.key === 'Escape') {
      const popup = document.getElementById('sdx-hc-popup');
      if (popup && popup.getAttribute('aria-hidden') === 'false') closeHealthClaims();
    }
  });

  if (drawer) {
    drawer.querySelectorAll('[data-sdx-ilib-drawer-close]').forEach((el) => {
      el.addEventListener('click', closeDrawer);
    });
    document.addEventListener('keydown', (e) => {
      if (e.key === 'Escape' && drawer.getAttribute('aria-hidden') === 'false') closeDrawer();
    });
  }

  if (searchInput) {
    let t = null;
    searchInput.addEventListener('input', () => {
      clearTimeout(t);
      t = setTimeout(() => {
        state.search = searchInput.value.trim();
        renderGrid();
      }, 120);
    });
  }

  function maybeOpenFromHash() {
    const m = window.location.hash.match(/^#icerik-(.+)$/);
    if (!m) return;
    // Browser bazen hash'i URL-encoded döner (%C2%AE vb).
    // state.byId key'leri ham karakterli (®) — decode et.
    let id = m[1];
    try { id = decodeURIComponent(id); } catch (_) { /* keep raw */ }
    if (state.byId[id]) openDrawer(id);
  }

  // Runtime metaobjects can contain multiple entries with the same name
  // (per-product variant, e.g. "Magnezyum 80mg" + "Magnezyum 250mg"). The previous
  // build-time export deduped by name; preserve that visual parity here.
  function dedupByName(ingredients) {
    const byKey = new Map();
    for (const rec of ingredients || []) {
      const key = (rec.name || '').trim().toLowerCase();
      if (!key) continue;
      const existing = byKey.get(key);
      if (!existing) {
        byKey.set(key, Object.assign({}, rec, {
          products: (rec.products || []).slice()
        }));
        continue;
      }
      // Enrich non-empty text fields from later entries if first was empty
      for (const k of ['latin_name', 'description', 'daily_dose', 'food_sources',
                       'function_text', 'evidence_url', 'country_of_origin']) {
        if (!existing[k] && rec[k]) existing[k] = rec[k];
      }
      if (!existing.image && rec.image) existing.image = rec.image;
      if ((!existing.benefits || existing.benefits.length === 0) && rec.benefits && rec.benefits.length) {
        existing.benefits = rec.benefits;
      }
      if ((!existing.references || existing.references.length === 0) && rec.references && rec.references.length) {
        existing.references = rec.references;
      }
      if ((!existing.raw_material_analysis || existing.raw_material_analysis.length === 0) && rec.raw_material_analysis && rec.raw_material_analysis.length) {
        existing.raw_material_analysis = rec.raw_material_analysis;
      }
      // Concatenate products (dedup by handle within the merged list)
      const seenHandles = new Set(existing.products.map((p) => p.handle));
      for (const p of (rec.products || [])) {
        if (!seenHandles.has(p.handle)) { existing.products.push(p); seenHandles.add(p.handle); }
      }
      // Union health_claims (text-based dedup)
      if (rec.health_claims && rec.health_claims.length) {
        const seenClaims = new Set(existing.health_claims || []);
        existing.health_claims = (existing.health_claims || []).slice();
        for (const hc of rec.health_claims) {
          if (!seenClaims.has(hc)) { existing.health_claims.push(hc); seenClaims.add(hc); }
        }
      }
    }
    // Refresh total_products
    const result = Array.from(byKey.values());
    result.forEach((r) => { r.total_products = (r.products || []).length; });
    return result;
  }

  async function loadData() {
    try {
      let data;
      // Inline mode: read pre-rendered JSON from <script> tag (Liquid metaobject runtime)
      if (srcUrl && srcUrl.indexOf('inline:') === 0) {
        const inlineId = srcUrl.slice('inline:'.length);
        const el = document.getElementById(inlineId);
        if (!el) throw new Error('Inline data element not found: ' + inlineId);
        data = JSON.parse(el.textContent);
      } else {
        const res = await fetch(srcUrl, { credentials: 'same-origin' });
        if (!res.ok) throw new Error('HTTP ' + res.status);
        data = await res.json();
      }
      // Dedup by name to preserve previous JSON-export parity
      data.ingredients = dedupByName(data.ingredients);
      state.data = data;
      state.byId = {};
      (data.ingredients || []).forEach((r) => { state.byId[r.id] = r; });
      renderFilters();
      if (isSSR) {
        bindCardClicks();      // drawer intercept (veri hazır → preventDefault aktif)
        applyFilterSSR();
      } else {
        renderGrid();
      }
      maybeOpenFromHash();
      // Library zaten yüklüyken kullanıcı farklı bir #icerik-X hash'iyle gelirse (örn search overlay'den) trigger.
      window.addEventListener('hashchange', maybeOpenFromHash);
    } catch (err) {
      // SSR modda kartlar server-rendered ve linkler doğal çalışır — hata gösterme,
      // yalnız filtre/arama bind et (drawer'sız degrade).
      if (isSSR) {
        renderFilters();
        console.error('[sdx-ilib]', err);
        return;
      }
      if (loadingEl) loadingEl.hidden = true;
      if (emptyEl) {
        emptyEl.hidden = false;
        emptyEl.textContent = 'İçerik listesi yüklenemedi. Lütfen sayfayı yenileyin.';
      }
      console.error('[sdx-ilib]', err);
    }
  }

  loadData();
})();



/* R7.1 m21 R2 Menşei promote */
(function(){
  if (typeof window === 'undefined' || !document) return;
  function promote(drawer) {
    if (!drawer || drawer.dataset.r71MenseiPromoted === '1') return;
    drawer.dataset.r71MenseiPromoted = '1';
    var rows = drawer.querySelectorAll('.sdx-ilib-drawer__info-row');
    rows.forEach(function(row) {
      var label = row.querySelector('.sdx-ilib-drawer__info-label');
      if (!label) return;
      var labelText = (label.textContent || '').trim();
      if (labelText === 'Menşei' || labelText === 'Menşe') {
        row.classList.add('sdx-ilib-drawer__info-row--promoted');
        label.classList.add('sdx-ilib-drawer__section-title');
      }
      if (labelText === 'Vücuttaki işlevi') {
        row.classList.add('sdx-ilib-drawer__info-row--promoted');
        label.classList.add('sdx-ilib-drawer__section-title');
      }
    });
  }
  function linkifyRefs(drawer) {
    if (!drawer || drawer.dataset.r71RefsLinked === '1') return;
    var refLists = drawer.querySelectorAll('.sdx-ilib-drawer__references-list, .sdx-ilib-drawer__references li');
    var any = false;
    refLists.forEach(function(node) {
      var html = node.innerHTML;
      var newHtml = html.replace(/(https?:\/\/[^\s<"]+)/g, function(u){
        return '<a href="' + u + '" target="_blank" rel="noopener noreferrer">' + u + '</a>';
      });
      if (newHtml !== html) { node.innerHTML = newHtml; any = true; }
    });
    if (any) drawer.dataset.r71RefsLinked = '1';
  }
  var mo = new MutationObserver(function(mutations){
    mutations.forEach(function(mu){
      mu.addedNodes.forEach(function(n){
        if (n.nodeType !== 1) return;
        var drawer = n.matches && n.matches('[data-sdx-ilib-drawer-body]') ? n : (n.querySelector && n.querySelector('[data-sdx-ilib-drawer-body]'));
        if (drawer) { promote(drawer); linkifyRefs(drawer); }
        if (n.matches && n.matches('.sdx-ilib-drawer__info-row')) {
          // re-run promote on its parent drawer-body
          var parent = n.closest('[data-sdx-ilib-drawer-body]');
          if (parent) { parent.dataset.r71MenseiPromoted = '0'; promote(parent); }
        }
      });
    });
  });
  function start(){
    mo.observe(document.body, {childList: true, subtree: true});
    document.querySelectorAll('[data-sdx-ilib-drawer-body]').forEach(function(d) { promote(d); linkifyRefs(d); });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start);
  else start();
})();
/* r11-ssr-cache-bump 1787911001 */
